import { render, staticRenderFns } from "./Danni.vue?vue&type=template&id=55ab303e"
import script from "./Danni.vue?vue&type=script&lang=js"
export * from "./Danni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports